import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 28px;
  display: grid;
  grid-gap: 2px;
`;
